
import Swiper from 'vux/src/components/swiper/swiper.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'


export default {
components: {
Swiper,
XButton,
GroupTitle,
XDialog
},
data() {
return {
showQr: false,
qrCode: '',
demo01_index: 0,
imgList: []

}
},
mounted: function () {
document.title = '个性名片';
this.$nextTick(function () {
this.$vux.loading.show('数据加载中');
this.$http.get(this.tianYiWebUrl + '/wechat/uc/ajaxGetUserCardBgList').then(r => {
if (r.data.code === 200) {
this.imgList = r.data.data
}
});
this.$vux.loading.hide()
})
},
methods: {
createAndShow() {
let currentId = this.imgList[this.demo01_index]['id'];
this.$vux.loading.show('数据处理中');
this.$http.get(this.tianYiWebUrl + '/wechat/uc/createUserCard', {params: {id: currentId}}).then(r => {
if (r.data.code === 200) {
this.qrCode = r.data.data;
this.showQr = true;
}else if(r.data.code === 500) {
this.$vux.loading.hide();
this.$vux.alert.show({
title: '提示',
content: r.data.message
})
}
});
this.$vux.loading.hide()
},
}
};



// WEBPACK FOOTER //
// ./src/components/uc/UserCard.vue